import React, { useEffect, useState, useContext } from 'react'
import POListHeader from './POListHeader'
import POListInner from './POListInner'
import POListFooter from './POListFooter'
import { appContext } from '../../../../App'
import { getPOList, getPOSettings, savePOSettings, deletePO } from '../PurchaseOrderFunctions'

export const poListControllerContext = React.createContext()

function usePOListController() {
  const app = useContext(appContext)
  const [recordPerPage, setRecordPerPage] = useState(0)
  const [recPP, setRecPP] = useState(0)
  const [page, setPage] = useState(1)
  const [totalPage, setTotalPage] = useState(0)
  const [poList, setPOList] = useState([])
  const [poListCopy, setPOListCopy] = useState([])
  const [poSettings, setPOSettings] = useState(null)

  // Filters
  //const [dateFilter, setDateFilter] = useState(null)
  const [searchInputFilter, setSearchInputFilter] = useState({ search_input: '' })
  //const [sortByFilter, setSortByFilter] = useState({ sort_by: { date_time_created: -1 }}) // sort from the backend
  const [sortBy, setSortBy] = useState(null) // sort from local data

  const [startSlice, setStartSlice] = useState(0)
  const [endSlice, setEndSlice] = useState(0)
  const [poListSorted, setPOListSorted] = useState(false)
  const [foundUnpostedPO, setFoundUnpostedPO] = useState(null)
  const [selectAll, setSelectAll] = useState(null)
  const [selectedPOId, setSelectedPOId] = useState([])

  const sortPOListBy = (column) => {
    const sortByDateTimeCreated = () => {
      poList.sort((a, b) => {
        let sorted
        if (!poListSorted)
          sorted = ((new Date(a.date_time_created).getTime()) - (new Date(b.date_time_created).getTime()))
        else
          sorted = ((new Date(b.date_time_created).getTime()) - (new Date(a.date_time_created).getTime()))
        return sorted
      })
    }

    const sortByDatePrepared = () => {
      poList.sort((a, b) => {
        let sorted
        if (!poListSorted)
          sorted = ((new Date(a.date_prepared).getTime()) - (new Date(b.date_prepared).getTime()))
        else
          sorted = ((new Date(b.date_prepared).getTime()) - (new Date(a.date_prepared).getTime()))
        return sorted
      })
    }

    const sortByPOID = () => {
      poList.sort((a, b) => {
        let x, y
        if (!poListSorted) {
          x = a._id.toLowerCase()
          y = b._id.toLowerCase()
        } else {
          x = b._id.toLowerCase()
          y = a._id.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByPreparedBy = () => {
      poList.sort((a, b) => {
        let x, y
        if (!poListSorted) {
          x = a.prepared_by.toLowerCase()
          y = b.prepared_by.toLowerCase()
        } else {
          x = b.prepared_by.toLowerCase()
          y = a.prepared_by.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByReferenceCode = () => {
      poList.sort((a, b) => {
        let x, y
        if (!poListSorted) {
          x = a.reference_code.toLowerCase()
          y = b.reference_code.toLowerCase()
        } else {
          x = b.reference_code.toLowerCase()
          y = a.reference_code.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByRemarks = () => {
      poList.sort((a, b) => {
        let x, y
        if (!poListSorted) {
          x = a.remarks.toLowerCase()
          y = b.remarks.toLowerCase()
        } else {
          x = b.remarks.toLowerCase()
          y = a.remarks.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByStatus = () => {
      poList.sort((a, b) => {
        let x, y
        if (!poListSorted) {
          x = a.status.toLowerCase()
          y = b.status.toLowerCase()
        } else {
          x = b.status.toLowerCase()
          y = a.status.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    switch (column) {
      case 'date_time_created': sortByDateTimeCreated()
        break
      case 'date_prepared': sortByDatePrepared()
        break
      case 'po_id': sortByPOID()
        break
      case 'prepared_by': sortByPreparedBy()
        break
      case 'reference_code': sortByReferenceCode()
        break
      case 'remarks': sortByRemarks()
        break
      case 'status': sortByStatus()
        break
      default:
    }

    setPOListSorted(!poListSorted)
    setPOList(poList)
  }

  const filterPOList = (searchString) => {
    let tempPOList = []

    poListCopy.forEach((po_item, i) => {
      po_item.item_full_description = `${po_item._id} ${po_item.supplier} ${po_item.prepared_by} ${po_item.reference_code} ${po_item.remarks} ${po_item.status}`
    })

    poListCopy.forEach(po_item => {
      let found = true
      searchString.split(' ').forEach((search_string_item, i) => {
        found = (found && (po_item.item_full_description.toLowerCase().search(search_string_item.toLowerCase()) !== -1))
      })
      if (found) tempPOList.push(po_item)
    })

    setPOList(tempPOList)

    setAllCheck(false)
    setSelectAll(false)

    setPage(1)
  }

  const batchDeleteSelectedPO = async () => {
    for (let id of selectedPOId) await deletePO(app, id)

    // Reload/Updte data view
    reloadPOList()

    setAllCheck(false)
    setSelectAll(false)

    // Reset the selectedSIId to empty array again
    setSelectedPOId([])
  }

  const setAllCheck = (check) => {
    const poCheckBoxes = document.querySelectorAll('.po-checkbox')
    let tempPOIdList = []

    // Reset the list
    setSelectedPOId([])

    // First checked all checkbox that is not checked
    poCheckBoxes.forEach((checkBox, i) => {
      const poId = checkBox.closest('.po-item').id
      if (check) tempPOIdList.push(poId)
      checkBox.checked = check
    })

    setSelectedPOId(tempPOIdList)
  }

  const addSelectedPOId = (po_id) => {
    setSelectedPOId([...selectedPOId, po_id])
  }

  const removeSelectedPOId = (po_id) => {
    setSelectedPOId(selectedPOId.filter((id) => id !== po_id))
  }

  const getTotalRecords = () => poList.length

  const reloadPOList = async () => {
    setRecordPerPage(poSettings.footer.record_per_page)
    setRecPP(poSettings.footer.record_per_page)

    //const po_list = await getPOList(app, {date: poSettings.date, ...sortByFilter})
    const po_list = await getPOList(app, {date: poSettings.date})
    setPOList(po_list)
    setPOListCopy(po_list)
    setSortBy(null)
  }
  
  useEffect(() => {
    const init = async () => {
      const po_settings = await getPOSettings(app)
      setPOSettings(po_settings)
    }

    init()

   /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => { setAllCheck(selectAll) }, [selectAll])

  useEffect(() => {
    if (poSettings) reloadPOList()
   /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poSettings])

  useEffect(() => {
    // set total page
    setTotalPage(Math.ceil(getTotalRecords() / recordPerPage))

    setStartSlice((page - 1) * recordPerPage)
    setEndSlice(page * recordPerPage)

    if (poList) setFoundUnpostedPO( poList.find( po => (po.status === 'Unposted') ) )
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordPerPage, poList, page])

  const obj = {
    poList: poList,
    poSettings: [poSettings, setPOSettings],
    //sortByFilter: [sortByFilter, setSortByFilter],
    sortBy: [sortBy, setSortBy],
    searchInputFilter: [searchInputFilter, setSearchInputFilter],
    startSlice: [startSlice, setStartSlice],
    endSlice: [endSlice, setEndSlice],
    recordPerPage: [recordPerPage, setRecordPerPage],
    recPP: [recPP, setRecPP],
    page: [page, setPage],
    selectAll: [selectAll, setSelectAll],
    batchDeleteSelectedPO,
    addSelectedPOId,
    removeSelectedPOId,
    selectedPOId,
    foundUnpostedPO,
    getTotalRecords,
    totalPage,
    reloadPOList,
    savePOSettings,
    sortPOListBy,
    filterPOList,
    poListSorted
  }

  return (obj)
}

function POListController() {
  const poListController = usePOListController()
  return (
    <React.Fragment>
      <poListControllerContext.Provider value={poListController}>
        <POListHeader />
        <POListInner />
        <POListFooter />
      </poListControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(POListController)